import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import ProductIcon01 from '../../assets/product-icon-01.png';
import ProductIcon02 from '../../assets/product-img-02.png';
import ProductIcon03 from '../../assets/product-img-03.png';
import ProductIcon04 from '../../assets/product-img-04.png';
import ProductIcon05 from '../../assets/product-img-05.png';
import ProductIcon06 from '../../assets/product-img-06.png';
import ProductIcon07 from '../../assets/product-img-07.png';
import ProductIcon08 from '../../assets/product-img-08.png';
import ProductIcon09 from '../../assets/product-img-09.png';
import ProductIcon10 from '../../assets/product-img-10.png';
import ProductIcon11 from '../../assets/product-img-11.png';
import CustomerSay from '../../components/CustomerSay';
import FeelTrust from '../../components/feelTrust';
import { Layout } from '../../components/page-layout';
import Question from '../../components/questions';
import Carousel from './carousel';
import ChoosingProduct from '../../components/choosingProduct';

const GlobalStyle = createGlobalStyle`
  body {
    background: #fff;
    color: #222;
    font-size: 18px;
    letter-spacing: 0;
  }
`;

const Main = styled.div`
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 0;
`;

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 64px 80px 0 80px;
  gap: 32px;
  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    gap: 0;
    padding: 64px 120px 0 120px;
  }
`;

const HeroText = styled.div`
  background: #fff;
  margin-bottom: 0;
  max-width: 600px;
`;

const HeroTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1rem;
  color: #181818;
  letter-spacing: -0.01em;
`;

const HeroDesc = styled.p`
  font-size: 1.15rem;
  margin-bottom: 2rem;
  color: #222;
`;

const AmazonButton = styled.a`
  display: inline-block;
  background: #F87B15;
  color: #fff;
  border-radius: 999px;
  padding: 0.75rem 2rem;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: #d96a10;
  }
`;

const CarouselBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 375px;
  max-width: 712px;
  width: 100%;
`;

const FeaturesSection = styled.section`
  padding: 64px 80px 0 80px;
  @media (min-width: 900px) {
    padding: 64px 120px 0 120px;
  }
`;

const FeaturesTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  color: #181818;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  @media (min-width: 900px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FeatureCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
`;

const FeatureIcon = styled.img`
  margin-bottom: 0.5rem;
  width: 48px;
  height: 48px;
`;

const FeatureHeading = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
`;

const FeatureDesc = styled.p`
  font-size: 0.98rem;
  color: #555;
`;

const AppFeaturesSection = styled.section`
  padding: 48px 0 0 0;
  margin-bottom: 80px;
  @media (min-width: 900px) {
    padding: 48px 0 0 0;
  }
`;

const AppFeaturesTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2.5rem;
  color: #181818;
`;

const AppFeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  padding: 0 32px;
  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    padding: 0 120px;
  }
`;

const AppFeatureCard = styled.div<{ bg: string }>`
  background: ${({ bg }) => bg};
  border-radius: 32px;
  height: 750px;
  max-width: 500px;
  min-width: 400px;
  margin: 0 auto;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

const AppFeatureImg = styled.img`
  width: 100%;
  max-width: 500px;
  height: 100%;
  margin: 0 auto;
  display: block;
  object-fit: contain;
  z-index: 1;
`;

const AppFeatureText = styled.div<{ align?: string }>`
  width: 100%;
  text-align: center;
  z-index: 2;
  ${({ align }) =>
    align === 'middle'
      ? `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 24px;
    box-sizing: border-box;
  `
      : `
    margin-bottom: ${align === 'bottom' ? '0' : '24px'};
    margin-top: ${align === 'bottom' ? 'auto' : '24px'};
  `}
`;

const AppFeatureHeading = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  margin-top: 24px;
`;

const AppFeatureDesc = styled.p`
  color: #444;
  font-size: 1.05rem;
  padding: 0 12px;
`;

const CustomerSayWrapper = styled.section`
  margin-top: 80px;
`;

export default function IndoorPanTiltCamera() {
  return (
    <Layout showCommonFooter>
      <GlobalStyle />
      <Main>
        <HeroSection>
          <HeroText>
            <HeroTitle>Sensforge Pan-Tilt Indoor Camera</HeroTitle>
            <HeroDesc>
              The Pan-Tilt Indoor Camera gives you 360° coverage, AI-powered tracking, and 2.5K HD video, so you can capture every moment even while you're away.
            </HeroDesc>
            <AmazonButton href="https://www.amazon.com/dp/B0F22F8CZP" target="_blank" rel="noopener noreferrer">
              Buy on Amazon
            </AmazonButton>
          </HeroText>
          <CarouselBox>
            <Carousel />
          </CarouselBox>
        </HeroSection>

        <FeaturesSection>
          <FeaturesTitle>Features to capture your memories</FeaturesTitle>
          <FeaturesGrid>
            <FeatureCard>
              <FeatureIcon src={ProductIcon01} alt="360 Icon" />
              <FeatureHeading>360° pan & 90° tilt</FeatureHeading>
              <FeatureDesc>Full-room coverage, no blind spots.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon02} alt="HD Icon" />
              <FeatureHeading>2.5K HD video</FeatureHeading>
              <FeatureDesc>See every detail crystal clear.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon03} alt="AI Icon" />
              <FeatureHeading>AI detection for FREE</FeatureHeading>
              <FeatureDesc>Detect humans, pets, & faces without a subscription.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon04} alt="Two-Way Icon" />
              <FeatureHeading>Two-Way Communication</FeatureHeading>
              <FeatureDesc>Stay connected—call your camera from the app or vice versa.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon05} alt="Night Vision Icon" />
              <FeatureHeading>Color & infrared night vision</FeatureHeading>
              <FeatureDesc>Stay sharp, even in complete darkness.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon06} alt="Local Storage Icon" />
              <FeatureHeading>Local storage</FeatureHeading>
              <FeatureDesc>Get local storage with your included SD card, or upgrade to cloud storage.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon07} alt="Privacy Shutter Icon" />
              <FeatureHeading>Privacy shutter</FeatureHeading>
              <FeatureDesc>Turn on privacy mode anytime.</FeatureDesc>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src={ProductIcon08} alt="Wired Camera Icon" />
              <FeatureHeading>Wired camera</FeatureHeading>
              <FeatureDesc>No power issues with this one!</FeatureDesc>
            </FeatureCard>
          </FeaturesGrid>
        </FeaturesSection>

        <AppFeaturesSection>
          <AppFeaturesTitle>App Features</AppFeaturesTitle>
          <AppFeaturesGrid>
            <AppFeatureCard bg="#ffaf6e">
              <AppFeatureText align="top">
                <AppFeatureHeading>Home Security Overview</AppFeatureHeading>
                <AppFeatureDesc>
                  Easily monitor all your devices from one central hub. Capture every moment and preserve your memories with ease.
                </AppFeatureDesc>
              </AppFeatureText>
              <AppFeatureImg src={ProductIcon09} alt="Home Security Overview" />
            </AppFeatureCard>
            <AppFeatureCard bg="#98c2f8">
              <AppFeatureImg src={ProductIcon10} alt="Direct Call Camera" />
              <AppFeatureText align="middle">
                <AppFeatureHeading>Direct Call Camera</AppFeatureHeading>
                <AppFeatureDesc>
                  Use Two-Way Audio to call your camera and talk to a loved one on the other end.
                </AppFeatureDesc>
              </AppFeatureText>
            </AppFeatureCard>
            <AppFeatureCard bg="#a9dabb">
              <AppFeatureImg src={ProductIcon11} alt="Advanced Detection Settings" />
              <AppFeatureText align="bottom">
                <AppFeatureHeading>Advanced Detection Settings</AppFeatureHeading>
                <AppFeatureDesc>
                  Use smart detection filters to identify and sort different types of activity.
                </AppFeatureDesc>
              </AppFeatureText>
            </AppFeatureCard>
          </AppFeaturesGrid>
        </AppFeaturesSection>

        <Question />
        <CustomerSayWrapper>
        <CustomerSay />
        </CustomerSayWrapper>
        <ChoosingProduct />
        <FeelTrust />
      </Main>
    </Layout>
  );
}